<template>
  <referral-details :id="selectedReferral" v-if="selectedReferral" @close="selectedReferral = null" :terms="terms.receiving" direction="received" />
  <referral-index direction="received" @selected="selectedReferral = $event" v-else />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ReferralDetails from './ReferralDetails.vue'
import ReferralIndex from './ReferralIndex.vue'
export default {
  components: { ReferralIndex, ReferralDetails },
  props: {
    page: Object
  },
  data () {
    return {
      selectedReferral: null,
      terms: {
        sending: '',
        receiving: '',
        privacy: ''
      },
      loading: true
    }
  },
  computed: {
    ...mapState(['referralTerms', 'selectedOffice'])
  },
  watch: {
    selectedOffice: {
      handler () {
        this.selectedReferral = null
      },
      deep: true
    }
  },
  created () {
    this.loadReferralTerms()
  },
  methods: {
    ...mapActions(['fetchReferralTerms']),
    loadReferralTerms () {
      if (!this.referralTerms) {
        this.fetchReferralTerms().then(() => {
          this.terms = this.referralTerms
          this.loading = false
        })
      } else {
        this.terms = this.referralTerms
        this.loading = false
      }
    }
  }
}
</script>
